import { generateUniqueId } from '../../helpers/common';

export const SET_SELECTED_PATH = generateUniqueId();
export const TOGGLE_LOG_OUT_DIALOG = generateUniqueId();
export const TOGGLE_SIDE_BAR = generateUniqueId();